import React from 'react'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {DashboardModuleIcon} from '@csrc/assets/icons'

export const dashboardNavigation = [
	{
		id: 'akh.dashboard',
		title: 'dashboard.nav.dashboard',
		icon: <FontAwesomeIcon icon={DashboardModuleIcon}/>,
		navLink: '/dashboard',
		action: 'call',
		resource: 'general'
	}
]
